import React from 'react'

const News = () => {
  return (
    <div className='h-8 bg-white'>News</div>
  )
}

export default News